import React, { useState, memo } from "react";
import { KanbanScripts } from "./KanbanScripts";
import { Select } from "antd";
import { Spin, Input, Popover, DatePicker } from "../../../BP2Components";
import ProcessesDropdown from "../../../ProcessesDropdown/ProcessesDropdown";
import sanitizeHtml from "sanitize-html";
import moment from "moment";

const { Option } = Select;

const ItemContent = memo(
   ({ columnTechName, showColumnName, width, columns, itemValue, saveItemValue }) => {
      //processes
      if (columnTechName === "__showProcesses") {
         return <ProcessesDropdown api_instanceStatus={itemValue?.["api_instanceStatus"]} />;
      }
      const column = columns.find(({ techName }) => columnTechName === techName);
      const enumType = column?.enumType || null;
      const [editValue, setEditValue] = useState(false);

      const editItem = (value, techName) => {
         if (value != itemValue[KanbanScripts.getTitleFromTechName(techName, columns)]) {
            if (enumType === "int") {
               if (!isNaN(value)) {
                  saveItemValue({
                     ...itemValue,
                     [KanbanScripts.getTitleFromTechName(techName, columns)]: value,
                  });
               }
            } else {
               saveItemValue(
                  {
                     ...itemValue,
                     [KanbanScripts.getTitleFromTechName(techName, columns)]: value,
                  },
                  techName,
               );
            }
         }
         setEditValue(false);
      };

      if (editValue) {
         //select
         if (enumType === "dict" || enumType === "sql") {
            const options = {
               ...column?.values?.reduce((previousValue, currValue) => {
                  previousValue[Object.keys(currValue)[0]] = currValue?.[Object.keys(currValue)[0]];
                  return previousValue;
               }, {}),
            };

            return Object.keys(options).length > 0 ? (
               <Select
                  showSearch
                  defaultValue={
                     itemValue?.[KanbanScripts.getTitleFromTechName(columnTechName, columns)]
                        ?.value || null
                  }
                  open={true}
                  onChange={(e) =>
                     editItem(
                        {
                           id: Object.keys(options).find((key) => options[key] == e),
                           value: e,
                        },
                        columnTechName,
                     )
                  }
                  onBlur={() => setEditValue(false)}
               >
                  {Object.entries(options).map(([id, val]) => (
                     <Option value={val} key={id}>
                        {val}
                     </Option>
                  ))}
               </Select>
            ) : (
               <Spin className="kanban-spin-loader" />
            );

            //date-picker
         } else if (enumType === "date_time" || enumType === "date") {
            return (
               <DatePicker
                  isOpen={true}
                  size="small"
                  className="gx-ml-1"
                  defaultValue={moment(
                     itemValue?.[KanbanScripts.getTitleFromTechName(columnTechName, columns)],
                  )}
                  onChange={(e) => {
                     if (e?.format("yyyy-MM-DD HH:mm:ss")) {
                        editItem(e?.format("yyyy-MM-DD HH:mm:ss"), columnTechName);
                     }
                  }}
                  onOpenChange={(e) => !e && setEditValue(false)}
                  onClickOutside={() => setEditValue(false)}
               />
            );
         } else {
            //input
            let defValue = itemValue?.[KanbanScripts.getTitleFromTechName(columnTechName, columns)];
            if (defValue === "") {
               defValue = "-";
            }
            return (
               <Input
                  defaultValue={defValue}
                  name={"input"}
                  onBlur={(e) => editItem(e.target.value, columnTechName)}
                  onPressEnter={(e) => e.target.blur()}
                  autoFocus={true}
                  style={{ width: "95%" }}
               />
            );
         }
      } else {
         // not-edited
         let defValue =
            itemValue?.[KanbanScripts.getTitleFromTechName(columnTechName, columns)]?.value ??
            itemValue?.[KanbanScripts.getTitleFromTechName(columnTechName, columns)];

         // Handle case where defValue is an object that can't be rendered directly
         if (defValue && typeof defValue === "object") {
            // Try to extract a displayable value from the object
            defValue =
               defValue.humanReadableName ||
               defValue.value ||
               defValue.text1 ||
               defValue.technicalName ||
               defValue.id ||
               JSON.stringify(defValue);
         }

         if (defValue === "") {
            defValue = "-";
         }
         return (
            <Popover
               content={<span dangerouslySetInnerHTML={{ __html: sanitizeHtml(defValue) }}></span>}
               placement="right"
               trigger="hover"
               title={column?.title}
               dark={true}
               style={{ width: width }}
               overlayStyle={{ maxWidth: "350px" }}
               overlayClassName="kanban-item-popover-content"
            >
               <p
                  className={"kanban-item-value"}
                  onClick={(e) => {
                     !(e.ctrlKey && e.metaKey) && setEditValue(true);
                  }}
               >
                  {showColumnName ? (
                     <span style={{ fontWeight: "400" }}>
                        {KanbanScripts.getTitleFromTechName(columnTechName, columns) + ": "}
                     </span>
                  ) : (
                     ""
                  )}
                  {defValue?.id ?? defValue}
               </p>
            </Popover>
         );
      }
   },
);

export default ItemContent;
